import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import Multiselect from 'vue-multiselect';

export default {
	name: 'combohubconfiguration',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading,
		Multiselect
	},
	props: [],
	data() {
		return {
			isLoading: false,
			isLoadingSearch: false,
			hubzoneid: '',
			srchubzoneid: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			ParentHubID: '',
			HubID: '',
			hubname: '',
			DesHubID: '',
			DestHubName: '',
			listSourceHubNameData: [],
			listParentHubNameData: [],
			listSourceHubNameDataFlt: [],
			hubListObjData: [],
			fetchedHubs: [],
			listHubZoneData: [],
			newParentHubData: [],
			listConnectionNameData: [],
			listConnectionNameData2: [],
			listComboHubDetails: {},
			tableData: false,
			listParentHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			listSourceHubNameDataObj: {
				value: "",
				text: "",
			},
			listSourceHubNameDataObj3: {
				value: "",
				text: ""
			},
			listHubZoneObjData: {
				value: "",
				text: ""
			},
			listSrcHubZoneObjData: {
				value: "",
				text: ""
			},
			newParentHubObjData: {
				value: "",
				text: ""
			},
			listHubZoneObjDataFlt: {
				value: "",
				text: ""
			},
			listConnectionNameDataObj: {
				value: "",
				text: ""
			},
			listConnectionNameDataObj2: {
				value: "",
				text: "",
				routeMode: ""
			},
			fncAction: '',
			actData: {},
			hubLoading: '',
			parentHubLoading: '',
			listSourceHubAllData: [],
			dtoSourceHub: {},
			newParentHub: '',
			isactive: '',
			destHubObj:[],
			ParentHubIDArr:[]
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.getHubZoneData();
	},
	methods: {
		selectedHubzone(hubData) {
			this.listHubZoneObjData = hubData
			this.hubzoneid = hubData.value;
			this.hubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: '',
				hubcode: ''
			}
			this.ParentHubID = ''
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.ParentHubArr=[]
			this.$validator.reset()
			if (this.hubzoneid != undefined) {
				this.getParentHubNameList(this.hubzoneid)
			}
		},
		selectedSrcHubzone(hubData) {
			this.listSrcHubZoneObjData = hubData
			this.srchubzoneid = hubData.value;
			this.srchubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: ''
			}
			this.DesHubID = ''
			this.destHubObj=[]
			this.$validator.reset()
			if (this.srchubzoneid != undefined) {
				this.getSourceHubNameList(this.srchubzoneid)
			}
		},
		selectedNewParentHub(hubData) {
			this.newParentHubObjData = hubData
			this.newParentHubId = hubData.value;
			this.newParentHubName = hubData.text;
			this.newParentHub = hubData.text1
			this.$validator.reset()
		},
		selectedSourceHubName(selectedData) {
			this.listSourceHubNameDataObj = selectedData
			this.DesHubID = selectedData.value;
			this.DestHubName = selectedData.text1;
			this.$validator.validate('DestinationHub')
		},
		selectedHubName(selectedData) {
			this.hubListObjData = selectedData
			this.ParentHubID = selectedData.value;
			this.HubName = selectedData.text;
			this.getAllHubs();
		},
		selectedHubConnection(selectedData) {
			this.listConnectionNameDataObj = selectedData
			this.ConnectionID = selectedData.value;
			this.ConnectionName = selectedData.text;
			if (this.ConnectionID != undefined) {
				this.loadDisplayRoute()
			}
			this.$validator.validate('ConnectionID')
		},
		selectedParentHubName(selectedData) {
			this.ParentHubID = ''
			this.ParentHubArr=[]
			this.listConnectionNameDataObj = {
				text: '',
				value: ''
			}
			this.ConnectionID = ''
			this.listParentHubNameDataObj = selectedData
			this.ParentHubID = selectedData.value;
			this.hubname = selectedData.text1;
			this.$validator.validate('ParentHub')
		},
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubzone/list',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},
		getSourceHubNameList() {
			this.hubLoading = 'Loading Source Hub...'
			this.listSourceHubNameData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			this.input = ({
				hubZoneId: this.srchubzoneid
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubNameData = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameData.length; i++) {
						this.listSourceHubNameData.push({
							value: listSourceHubNameData[i].HubID,
							text: listSourceHubNameData[i].HubCode + ' - ' + listSourceHubNameData[i].HubName + ' (' + listSourceHubNameData[i].HubID + ')',
							text1: listSourceHubNameData[i].HubName,
							hubcode: listSourceHubNameData[i].HubCode
						})
					}
				}, error => {
					this.hubLoading = ''
					console.error(error)
				})
		},
		getParentHubNameList() {
			this.parentHubLoading = 'Loading Parent Hub...'
			this.listParentHubNameData = [];
			this.ParentHubIDArr=[];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			this.input = ({
				hubZoneId: this.hubzoneid
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.parentHubLoading = ''
					var listParentHubNameData = result.data.ResponseData;
					for (i = 0; i < listParentHubNameData.length; i++) {
						this.listParentHubNameData.push({
							value: listParentHubNameData[i].HubID,
							text: listParentHubNameData[i].HubCode + ' - ' + listParentHubNameData[i].HubName + ' (' + listParentHubNameData[i].HubID + ')',
							text1: listParentHubNameData[i].HubName,
							hubcode: listParentHubNameData[i].HubCode
						})
						this.newParentHubData.push({
							value: listParentHubNameData[i].HubID,
							text: listParentHubNameData[i].HubCode + ' - ' + listParentHubNameData[i].HubName + ' (' + listParentHubNameData[i].HubID + ')',
							text1: listParentHubNameData[i].HubName,
							hubcode: listParentHubNameData[i].HubCode
						})
					}
				}, error => {
					this.parenthubLoading = ''
					console.error(error)
				})
		},
		getAllComboHubConfigurations() {
			this.pageNo = 0
			var isErr = 0;
			if (!this.hubzoneidflt) {
				this.isSearchHubZoneErr = '1',
					this.SearchHubZoneErr = 'The HubZone field is required.'
				isErr = 1;
			} else {
				this.isSearchHubZoneErr = '',
					this.SearchHubZoneErr = ''
			}
			if (isErr == 1) {
				return false;
			} else {
				this.getAllComboHubConfigurationsDetails();
			}
		},
		addDTOBagProcessingHubDetail() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.listParentHubNameDataObj.value === this.DesHubID) {
				return this.$alertify.error('Parent Hub & Source Hub Should be Different')
			}
			this.input = {
				DTOBagParentHubId: this.ParentHubID,
				SourceHubId: this.DesHubID,
				DTOBagParentHubName: this.hubname,
				SourceHubName: this.DestHubName,
				CreatedBy: this.useremail
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'addDTOBagProcessingHubDetail',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(result.data.ReturnMessage)
						this.tableData = false
						this.resetForm();
					} else if (result.data.ResultCode == 101) {
						this.invalidTokenModal = false
						this.listComboHubDetails = result.data.ResponseData[0];
						this.dtoSourceHub = { dtoSourceHubID: this.listComboHubDetails.sourcehubid, dtoSourceHubName: this.listComboHubDetails.sourcehubname }
						this.tableData = true
						this.$alertify.error(result.data.ReturnMessage)
						this.newParentHubObjData = { value: this.listComboHubDetails.dtobagparenthubid, text: this.listComboHubDetails.dtobagparenthubname }
						document.getElementById("isactive").checked = this.listComboHubDetails.isactive;
						this.newParentHub = this.listComboHubDetails.dtobagparenthubname
					} else if (response.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage)
						this.resetForm();
						this.listComboHubDetails = '';
					}
				}, error => {
					self.isLoadingSearch = false;
					this.$alertify.error("Fetch Connection API error")
					console.error(error)
				})
		},
		updateHubDetails() {
			if (this.dtoSourceHub.dtoSourceHubID == this.newParentHubObjData.value) {
				return this.$alertify.error('Parent Hub & Source Hub Should be Different')
			}
			if (document.getElementById("isactive").checked == true) {
				this.isactive = true
			} else {
				this.isactive = false
			}
			this.input = {
				SourceHubId: this.dtoSourceHub.dtoSourceHubID,
				DTOBagParentHubId: this.newParentHubObjData.value,
				DTOBagParentHubName: this.newParentHub,
				IsActive: this.isactive,
				LastModifiedBy: this.useremail
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'updateDTOProcessingHubDetail',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					self.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(result.data.ReturnMessage)
						this.tableData = false
						this.resetForm();
					} else if (result.data.ResultCode == 101) {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage)
						// this.resetForm();
					} else if (response.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage)
						tthis.resetForm();
					}
				}, error => {
					self.isLoadingSearch = false;
					this.$alertify.error("Fetch Connection API error")
					console.error(error)
				})
		},
		onSubmit: function () {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						console.log('errors exist', this.errors);
						return false;
					} else {
						this.addDTOBagProcessingHubDetail();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm() {
			this.hubzoneid = '';
			this.ParentHubID = '';
			this.DesHubID = '';
			this.listParentHubNameDataObj = {
				value: '',
				text: '',
				hubcode: ''
			};
			this.listHubZoneObjData = {
				value: '',
				text: ''
			};
			this.listSrcHubZoneObjData = {
				value: '',
				text: ''
			};
			this.listConnectionNameDataObj = {
				value: '',
				text: ''
			};
			this.tableData = false;
			this.listResultHubobjData = {
				value: '',
				text: ''
			};
			this.listSourceHubNameDataObj = {
				value: '',
				text: ''
			};
			this.listParentHubNameDataObj = {
				value: "",
				text: "",
				hubcode: ''
			};
			this.routetypeitem = {
				id: '',
				text: ''
			};
			this.srchubzoneid = '';
			this.newParentHubData = [];
			this.newParentHubObjData = {
				value: '',
				text: ''
			};
			this.newParentHub = '';
			this.routetype = '';
			this.connectiontype = '';
			this.connectionname = '';
			this.resultHubID = '';
			this.ConnectionID = '';
			this.listSourceHubNameData = [];
			this.listParentHubNameData = [];
			this.parentHubLoading = '';
			this.hubLoading = '';
			this.$validator.reset();
			this.destHubObj =[]
			this.ParentHubIDArr=[]
		},
		closeStatusModal() {
			this.addmodalShow = false
		},
		takeAction() {
			this[this.fncAction]()
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/DTOProcessingHubDetails/DTOProcessingHubDetails.js